import Http from '../../../../network/Http'
import {NatGetExtractHistory} from './NatGetExtractHistory'
import {NatPostExtractHistory} from './NatPostExtractHistory'
import {ContentType} from '../../../../network/Constants'

export default class NatExtractHistoryRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // 抽出履歴一覧取得
    async getExtractHistory(extractCategory: string,
                            searchCondition: string): Promise<NatGetExtractHistory> {
        return await this.http.get(`/api/admin/extractHistory/${extractCategory}?${searchCondition}`)
    }

    // 抽出要求
    async postExtractRequest(extractCategory: string): Promise<NatPostExtractHistory> {
        return await this.http.post(
            `/api/admin/extractHistory/${extractCategory}`,
            {},
            ContentType.JSON,
        )
    }
}
